<template>
  <header id="header" class="header-area" v-if="showHeader">
    <transition name="slide" mode="out-in">
      <div key="header_back" class="header-area-wrapper left" v-if="showBack"
           @click="$router.go(-1)"
      >
        <img :src="require('@/assets/images/chevron_left.svg')" />
      </div>
      <div key="header_menu" class="header-area-wrapper left" v-else
           @click="showMenu"
      >
        <img :src="require('@/assets/images/menu.svg')" />
      </div>
    </transition>
    <transition key="back" name="slide" mode="out-in">
      <router-link class="header-area-wrapper" v-if="showTitle"
                   :to="{ name: 'auth.dashboard' }">
        <h2>{{ showTitle }}</h2>
      </router-link>
      <router-link class="header-area-wrapper" v-else
                   :to="{ name: 'auth.dashboard' }">
        <img :src="require('@/assets/images/logo_sas_landscape_darken.svg')"/>
      </router-link>
    </transition>
    <transition name="slide" mode="out-in">
      <router-link class="header-area-wrapper right" v-if="showSearch"
                   :to="{ name: 'auth.properties' }">
        <img :src="require('@/assets/images/search.svg')" />
      </router-link>
      <router-link class="header-area-wrapper right" v-else-if="showNext"
                   :to="showNext">
        <img :src="require('@/assets/images/chevron_right.svg')" />
      </router-link>
      <div key="header_menu" class="header-area-wrapper right" v-else-if="showUpdate && isOnline"
           @click.prevent="updateProperties()"
      >
        <img :src="require('@/assets/images/download.svg')" />
      </div>
      <div class="header-area-wrapper left" v-else></div>
    </transition>
    <div class="connection-offline" :class="isOffline ? 'active' : ''"></div>
  </header>
</template>

<script>
export default {
  name: 'HeaderArea',
  computed: {
    showHeader() {
      return this.$store.state.header;
    },
    showSearch() {
      return this.$store.state.headerSearch;
    },
    showBack() {
      return this.$store.state.headerBack;
    },
    showNext() {
      return this.$store.state.headerNext;
    },
    showTitle() {
      return this.$store.state.headerTitle;
    },
    showUpdate() {
      return this.$store.state.headerUpdate;
    },
  },
  methods: {
    showMenu() {
      this.$store.commit('menuShow');
    },
    async updateProperties() {
      this.$store.commit('fetchActive');
      await this.$store.dispatch('getDataProperties');
      this.$store.commit('fetchInactive');
    },
  },
};

</script>

<style scoped>
  .header-area {
    width: 100%;
    height: 65px;
    top: 0;
    left: 0;
    position: fixed;
    animation: slideUp .3s backwards;
    z-index: 8000;
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 15px;
    overflow: hidden;
    background-image: linear-gradient(
      180deg,
      var(--color-secondary),
      transparent
    );
  }
  .header-area img{
    max-width: 100%;
    height: 36px;
    object-fit: contain;
  }

  .header-area-wrapper {
    width: 100%;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .header-area-wrapper.left{
    justify-content: flex-start;
  }

  .header-area-wrapper.right{
    justify-content: flex-end;
  }

  .connection-offline{
    width: 100%;
    min-height: 0;
    position: absolute;
    top: 0;
    left: 0;
    background-color: red;
    transition: max-height .3s linear;
  }
  .connection-offline.active{
    min-height: 3px;
    transition: max-height .3s linear;
  }
</style>
